import { createRoot } from 'react-dom/client'
import { FooterMenuWidget } from './FooterMenuWidget.jsx'

const selector = '[data-nova-footer-menu]'

function parsePayload(element) {
  try {
    return JSON.parse(element.dataset.payload || '{}')
  } catch {
    return {}
  }
}

function mountFooterMenu(element) {
  if (element.__novaReactRoot) return

  element.__novaReactRoot = createRoot(element)
  element.__novaReactRoot.render(<FooterMenuWidget payload={parsePayload(element)} />)
}

function mountFooterMenus(root = document) {
  if (root.matches?.(selector)) {
    mountFooterMenu(root)
  }

  root.querySelectorAll?.(selector).forEach(mountFooterMenu)
}

mountFooterMenus()

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        mountFooterMenus(node)
      }
    })
  })
})

observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
})
